import * as e from "react";
import c from "../lib/SSRBase.es.js";
import a from "../defs/Percent.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(c, { ref: o, ...t, weights: a }));
r.displayName = "PercentIcon";
const s = r;
export {
  s as Percent,
  r as PercentIcon
};
